import {
  AddIcon,
  Button,
  DocumentIcon,
  ExpandIcon,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  PhoneIcon,
  ReminderIcon,
} from '@all-manager/design-system-v2';
import { useId } from 'react';
import AddUpdateReminder from '../../../reminders/external-components/AddUpdateReminder/AddUpdateReminder';
import AddUpdateContactModal from '../AddUpdateContactModal/AddUpdateContactModal';
import AddUpdateContractModal from '../AddUpdateContractModal/AddUpdateContractModal';
import { useProviderAddActions } from './useProviderAddActions';

type Props = {
  providerId: string;
}

export default function ProviderAddActions(props: Props) {
  const hook = useProviderAddActions();
  const buttonId = useId();
  const menuId = useId();

  return (
    <>
      <Button
        id={buttonId}
        aria-controls={hook.isMenuOpen ? menuId : undefined}
        aria-haspopup="true"
        aria-expanded={hook.isMenuOpen ? 'true' : undefined}
        variant="contained"
        size="small"
        startIcon={<AddIcon />}
        endIcon={<ExpandIcon />}
        onClick={hook.handleOpenMenu}
      >
        Ajouter
      </Button>

      <Menu
        id={menuId}
        anchorEl={hook.anchorEl}
        open={hook.isMenuOpen}
        onClose={hook.handleCloseMenu}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        slotProps={{ list: { 'aria-labelledby': buttonId } }}
      >
        <MenuItem onClick={() => hook.handleSelectAction('contract')}>
          <ListItemIcon>
            <DocumentIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Nouveau contrat</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => hook.handleSelectAction('contact')}>
          <ListItemIcon>
            <PhoneIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Nouveau contact</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => hook.handleSelectAction('reminder')}>
          <ListItemIcon>
            <ReminderIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Nouveau rappel</ListItemText>
        </MenuItem>
      </Menu>

      {hook.activeModal === 'contract' ? (
        <AddUpdateContractModal
          providerId={props.providerId}
          onClose={hook.handleCloseModal}
        />
      ) : null}

      {hook.activeModal === 'contact' ? (
        <AddUpdateContactModal
          providerId={props.providerId}
          onClose={hook.handleCloseModal}
        />
      ) : null}

      {hook.activeModal === 'reminder' ? (
        <AddUpdateReminder
          providerId={props.providerId}
          onClose={hook.handleCloseModal}
          navigatePath={`/providers/${props.providerId}/reminders`}
          displaySubjectField
        />
      ) : null}
    </>
  );
}
